import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@design-system';
import type { ReplyCatalog, TemplateAction } from '../api/api';

const ORDINALS = ['First', 'Second', 'Third'];

/** The three steps under the reply, each chosen from what Waterlily can do today. */
export function NextSteps(props: {
  actions: TemplateAction[];
  steps: ReplyCatalog['steps'];
  onChange: (index: number, step: ReplyCatalog['steps'][number]) => void;
}) {
  return (
    <section className="flex flex-col gap-3 rounded-xl border border-zinc-200 bg-white px-5 pb-5 pt-4">
      <div className="flex flex-col gap-1">
        <h2 className="text-base font-semibold">Suggested next steps</h2>
        <p className="text-[13px] text-zinc-600">
          The advisor sees these three under the reply. Only things Waterlily can do today are
          listed.
        </p>
      </div>
      {props.actions.map((action, index) => {
        const offered = props.steps.some(step => step.label === action.label);
        return (
          <div
            key={action.id}
            className="flex items-center gap-3"
          >
            <span
              aria-hidden
              className="flex size-7 flex-none items-center justify-center rounded-full bg-zinc-100 text-[13px] font-bold text-zinc-700"
            >
              {index + 1}
            </span>
            <Select
              value={action.label}
              onValueChange={label => {
                const step = props.steps.find(candidate => candidate.label === label);
                if (step) props.onChange(index, step);
              }}
            >
              <SelectTrigger
                aria-label={`${ORDINALS[index]} next step`}
                className="h-11 min-w-0 flex-1 bg-white"
              >
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {!offered && (
                  <SelectItem
                    value={action.label}
                    disabled
                  >
                    {action.label} (not available yet)
                  </SelectItem>
                )}
                {props.steps.map(step => (
                  <SelectItem
                    key={step.label}
                    value={step.label}
                  >
                    {step.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        );
      })}
    </section>
  );
}
